import React, { createContext } from "react";
import { Action, State } from "./type";

const initialState: State = {
  theme: "light",
  locale: "en",
  localeLink: "",
  baseUrl: "",
  isLogin: null,
  userInfo:null
};

const StoreContext = createContext<{
  state: State;
  dispatch: React.Dispatch<Action>;
}>({
  state: initialState,
  dispatch: () => null
});

export { initialState, StoreContext };
